import {
	ConfigLayer,
	MapModes,
	MapPosition,
	ReactMap,
} from '@innovyze/inno-map';
import { GeoJsonInputType } from '@innovyze/inno-map/map/services/types';
import { useReactMapConfig } from '@innovyze/stylovyze';
import { MapCardStyle } from '@Pages/NewSensor/NewSensor.styles';
import React from 'react';

export interface MapConfig {
	dataServices: Array<GeoJsonInputType>;
	position: MapPosition;
	mapMode: MapModes;
	layerConfig?: ConfigLayer[];
}

const SensorConfigurationMap = (props: MapConfig) => {
	const reactMapConfig = useReactMapConfig();

	return (
		<MapCardStyle>
			<ReactMap
				config={reactMapConfig}
				dataServices={props.dataServices || []}
				position={props.position || {}}
				mode={props.mapMode}
				layerConfig={props.layerConfig}
				autoResize
			/>
		</MapCardStyle>
	);
};

export default SensorConfigurationMap;
